import React, { useMemo } from 'react'
import moment from 'moment'
import '../styles/EditRecommendationModal.css'

function WeekDatePicker({
    selectedDateIndex = 0,
    onSelectDate,
    readOnly = false,
    isAddMode = false
}) {
    const weekDates = useMemo(() => {
        const startOfWeek = moment().startOf('isoWeek')
        return Array.from({ length: 7 }, (_, idx) => {
            const date = startOfWeek.clone().add(idx, 'days')
            return {
                date,
                dateStr: date.format('YYYY-MM-DD'),
                dayLabel: date.format('dd')[0], // e.g., "M", "T", ...
                dateNumber: date.date()
            }
        })
    }, [])

    const today = moment().startOf('day')

    const isValidIndex = (index) => index >= 0 && index < weekDates.length

    return (
        <div className="week-date-picker">
            <div className="date-selector-row">
                {weekDates.map((item, index) => {
                    const isPast = item.date.isBefore(today, 'day')
                    const isDisabled = readOnly || isPast
                    return (
                        <div
                            key={item.dateStr}
                            className={`date-cell 
                  ${selectedDateIndex === index ? 'active' : ''} 
                  ${isDisabled ? 'disabled' : ''}`}
                            onClick={() => {
                                if (!isDisabled && isValidIndex(index)) {
                                    onSelectDate(index)
                                }
                            }}
                        >
                            <div className="date-number">{item.dateNumber}</div>
                            <div className="day-label">{item.dayLabel}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}  

export default WeekDatePicker
